import { CSSProperties } from 'react';
import { StylesConfig } from 'react-select';

import { ICategoryOption } from 'features/challenges/interface/challenges';

/**
 * reactSelectStyles - css style object for react-select
 */
export const reactSelectStyles = {
	container: (provided, state) => ({
		...provided,
		pointerEvents: state.isDisabled ? 'unset' : 'all'
	}),
	option: (provided, state) => ({
		...provided,
		color: '#000000',
		backgroundColor: state.isSelected ? '#BDBDCF' : state.isDisabled ? '#e4e5ee' : '',
		':active': {
			backgroundColor: '#ecf0ff'
		},
		':hover': {
			backgroundColor: state.isSelected ? '#808095' : '#808095'
		},
		':focus': {
			backgroundColor: '#cacaca',
			outline: 0
		},
		padding: '10px 10px',
		cursor: 'pointer',
		margin: 0,
		borderBottom: '1px solid #f1f2f4'
	}),
	control: (provided, state) => ({
		color: '#fff',
		borderRadius: '10px',
		height: '43px',
		backgroundColor: state.isDisabled ? '#e9ecef' : 'transparent',
		padding: '0',
		zIndex: '2000',
		display: 'flex',
		cursor: state.isDisabled ? 'not-allowed' : 'pointer',
		border: '2px solid #f1f2f4'
	}),
	menu: (base) => ({
		...base,
		zIndex: 100,
		cursor: 'pointer',
		left: '0',
		boxShadow: 'none',
		border: '1px solid #f1f2f4'
	}),
	menuList: (styles) => ({
		...styles,
		background: '#ffffff',
		overflowY: 'auto', // Enable vertical scrolling
		maxHeight: '200px' // Set a maximum height for the menu list
	}),
	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = 'opacity 300ms';
		return {
			...provided,
			transition,
			color: '#081d34',
			backgroundColor: 'transparent',
			fontSize: '14px',
			fontWeight: '600'
		};
	},
	placeholder: (defaultStyles) => {
		return {
			...defaultStyles,
			color: '#808095'
		};
	},
	clearIndicator: (base: CSSProperties) => ({
		...base,
		cursor: 'pointer'
	}),
	dropdownIndicator: (base: CSSProperties, state: any) => ({
		...base,
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none'
	}),
	indicatorSeparator: () => ({
		width: '0'
	})
};

const dot = (color = 'transparent') => ({
	alignItems: 'center',
	display: 'flex',

	':before': {
		backgroundColor: color,
		borderRadius: 10,
		content: '" "',
		display: 'block',
		marginRight: 8,
		height: 10,
		width: 10
	}
});

export const colorStyles: StylesConfig<ICategoryOption, boolean> = {
	option: (styles: CSSProperties, { data }) => {
		return {
			...styles,
			...dot(data.dotColor)
		};
	},
	placeholder: (styles: CSSProperties) => ({ ...styles, ...dot() }),
	singleValue: (styles: CSSProperties, { data }) => ({ ...styles, ...dot(data.dotColor) })
};
